import { Money, ZahlungModel, TerminModel } from "./schemas";

export class VertragModel {
    // Vertragnepraunik
    Id: string;
    Name: string;

    Ampel: string;
    Kaufer1: string;
    Kaufer2: string;    
    KaufpreisVollstaendig: string;
    KaufpreisVollstaendigAmpel: string;
    Eingangsdatum: Date;
    KVTermin: Date;
    // Wohnung 
    StiegeNr: string;
    PLZ: string;
    Strasse: string;
    Top: string;
    // Wohnhausanlage
    BezeichnungExternesPortal: string;
    // Appointment
    Termine: TerminModel[];
    TermineNumber: string;
    // Appointment
    Zahlungen: ZahlungModel[];
    ZahlungenNumber: string;
}


// WEBPACK FOOTER //
// ./src/app/schemas/VertragModel.ts